export default __webpack_public_path__ + "static/media/forestly-expl-gradcam-05_DE.77b9f759.png";